<div class="bg-background-ground p-lg border-stroke-neutral-light flex flex-col border-b">
  <h1 class="title-small-semibold pb-xs">Catalogue national</h1>
  <div class="flex justify-between">
    <brn-select
      class="inline-block"
      (valueChange)="setCartographieCourante($event)"
      placeholder="Sélectionnez une cartographie"
    >
      <hlm-select-trigger class="w-max">
        {{ cartographie()?.nom || '' }}
      </hlm-select-trigger>
      <hlm-select-content>
        @for (cartographie of cartographies() | trierPar: 'nom'; track cartographie.id) {
          <hlm-option [value]="cartographie">{{ cartographie.nom }}</hlm-option>
        }
      </hlm-select-content>
    </brn-select>
    <hlm-input-group class="border-grey-3 text-grey-7 w-1/3">
      <input [(ngModel)]="formation" placeholder="Rechercher une formation" type="text" hlmInputGroupInput />
      @if (formation()) {
        <hlm-input-group-addon align="inline-end">
          <ng-icon class="mr-xs cursor-pointer" (click)="clearFormation()" hlm name="lucideX" />
        </hlm-input-group-addon>
      }
      <hlm-input-group-addon align="inline-end">
        <ng-icon hlm name="lucideSearch" />
      </hlm-input-group-addon>
    </hlm-input-group>

    <div class="gap-xs flex items-center justify-between">
      <button class="h-xxl" (click)="selectionnerSite()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter des formations
      </button>

      <button [appBadge]="nbFiltres()" (click)="openFiltres()" hlmBtn variant="secondary" size="xxl">
        <ng-icon hlm name="lucideListFilter" size="sm" />
      </button>
    </div>
  </div>
</div>
